import { colors, RISK_COLORS } from '@lmc/common/constants'
import type { FC } from 'react'
import styled from 'styled-components'

interface RiskValueProps {
  risk?: string
  value?: number
}

const RiskValue: FC<RiskValueProps> = ({ risk, value }) => {
  if ((!risk || !value) && value !== 0) return null

  const background =
    (risk && RISK_COLORS[risk as keyof typeof RISK_COLORS]) || colors.darkgrey
  const isSmall = riskValueLength(value) > 2

  return (
    <RiskContainer $background={background}>
      <RiskText $isSmall={isSmall}>{value || 0}</RiskText>
    </RiskContainer>
  )
}

const riskValueLength = (value: number): number => value.toString().length

const RiskContainer = styled.div<{ $background: string }>`
  display: flex;
  align-items: center;
  background: ${({ $background }) => $background};
  border-radius: 4px;
  flex-shrink: 0;
  height: 25px;
  justify-content: center;
  margin-right: 10px;
  user-select: none;
  width: 25px;
`

const RiskText = styled.span<{ $isSmall: boolean }>`
  color: white;
  font-size: ${({ $isSmall }) => ($isSmall ? 11 : 13)}px;
  margin-left: 1px;
`

export default RiskValue
